export const OVERLAY_SIZES = {
	SM: 'sm',
	MD: 'md',
	LG: 'lg',
};

export const OVERLAY_CONFIG = {
	[OVERLAY_SIZES.SM]: { min: 0, max: 629 },
	[OVERLAY_SIZES.MD]: { min: 630, max: 1023 },
	[OVERLAY_SIZES.LG]: { min: 1024, max: Infinity },
};
